/* eslint-disable no-unused-vars */
import { useState, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { selected_custom_audience } from 'store/selectors';
import { generalActions } from 'store/actions';

export const useFacade = (handleCloseWindow) => {
  const [search, setSearch] = useState('');
  const isChanged = useRef(true);
  const dispatch = useDispatch();

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);
  const selectedAudience = useSelector(selected_custom_audience);

  const { data, isSuccess } = manageCampaignsAPI.useGetCustomAudiencesListQuery();

  const [selectedAud, setSelectedAud] = useState(selectedAudience);

  const faundedAudience = useMemo(() => {
    if (!search) return data;
    return data.filter(({ cust_aud_name }) => {
      return cust_aud_name.toLowerCase().includes(search.toLowerCase());
    });
  }, [data, search]);

  const saveButtonAction = useCallback(() => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'customAudienceGoal',
        newValue: true,
      }),
    );
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'customAudienceObj',
        newValue: selectedAud,
      }),
    );
    handleCloseWindow();
  }, [selectedAud]);

  return {
    search,
    isChanged,
    handleSearchOnChange,
    handleClearSearchValue,
    faundedAudience,
    isSuccess,
    selectedAud,
    setSelectedAud,
    saveButtonAction,
  };
};
